import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=03b91c90&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=03b91c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b91c90",
  null
  
)

export default component.exports